import { Component, effect, inject, computed } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UsageService } from '@app/core/usage.service';
import { Dialog } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { DatePipe, DecimalPipe } from '@angular/common';
import { SubscriptionsService } from '@app/core/subscriptions.service';

@Component({
  selector: 'app-credit-check-dialog',
  imports: [Dialog, Button, DatePipe, DecimalPipe, RouterLink],
  templateUrl: './credit-check-dialog.component.html',
  styleUrl: './credit-check-dialog.component.scss'
})
export class CreditCheckDialogComponent {
  private router = inject(Router);
  private subscriptionsService = inject(SubscriptionsService);
  public usageService = inject(UsageService);

  // Computed properties for dialog content
  hasSubscription = computed(() => this.subscriptionsService.subscriptionSummary()?.status === 'ACTIVE');
  availableCredits = this.usageService.availableCredits;
  totalCreditLimit = this.usageService.totalCreditLimit;
  creditsUsed = this.usageService.creditsUsed;

  // Computed properties for subscription details
  subscriptionEndDate = computed(() => {
    const subscription = this.subscriptionsService.subscriptionSummary();
    if (!subscription) return null;
    return new Date(subscription.current_period_end);
  });

  daysUntilRenewal = computed(() => {
    const endDate = this.subscriptionEndDate();
    if (!endDate) return null;
    const now = new Date();
    const diffTime = endDate.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  });

  constructor() {
    // Close dialog when credits become available again
    effect(() => {
      const available = this.availableCredits();
      const isVisible = this.usageService.creditCheckDialogVisible();
      
      // Only close if dialog is visible and credits are available
      if (available > 0 && isVisible) {
        // Use setTimeout to avoid change detection issues
        // setTimeout(() => {
        //   this.usageService.hideCreditCheckDialog();
        // }, 0);
      }
    });
  }

  onClose() {
    console.log('onClose');
    this.usageService.hideCreditCheckDialog();
  }

  onUpgrade() {
    this.router.navigate(['/billing/plans']);
    this.onClose();
  }

  onManageBilling() {
    this.router.navigate(['/billing/plans']);
    this.onClose();
  }
}
